// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041436/js/" + chunkId + "." + {"44":"62093ec8","225":"aee636e2","481":"5f29df99","486":"8922deca","770":"4c037ca5"}[chunkId] + ".0.3024726096300644.chunk.js";
};